import React, {PropTypes} from 'react'
import {Link} from 'react-router'
import {Col, Row, Image, OverlayTrigger, Tooltip, Popover} from 'react-bootstrap'
import showToastr from '../../utils/showToastr'
import {connect} from 'react-redux'
import {Actions} from 'jumpstate'
import HorseReport from './HorseReport/HorseReport'
import DieReport from './DieReport/DieReport'
import Owner from './Owner/Owner'
import {MdFavorite, MdReport, IoIosPulseStrong, MdHistory} from '../Common/ReactIcons/icons'

const horseAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class HorseDetails extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      horse: this.props.info,
      isReportBoxVisible: false,
      isDieBoxVisible: false
    }
    this.likeHandler = this.likeHandler.bind(this)
    this.reportHandler = this.reportHandler.bind(this)
    this.dieHandler = this.dieHandler.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({horse: nextProps.info})
  }

  likeHandler () {
    const {horse} = this.state
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    if (!horse.likes.isLike) {
      Actions.horseLike(horse.id).then((res) => {
        this.setState({horse: this.props.currentHorse})
      })
    } else {
      Actions.horseUnlike(horse.id).then((res) => {
        this.setState({horse: this.props.currentHorse})
      })
    }
  }

  reportHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isReportBoxVisible: show})
  }

  dieHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', '', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isDieBoxVisible: show})
  }

  render () {
    const {horse, isReportBoxVisible, isDieBoxVisible} = this.state

    const ownerList = (
      <Popover id="owner-list" title={<span><MdHistory /> تاریخچه مالکین</span>}>
        {horse.owners.map(item => <Link key={item.id} to={`/owner/${item.key}`}><Owner info={item} /></Link>)}
      </Popover>
    )

    return (
      <Row className="Box">
        <HorseReport isVisible={isReportBoxVisible} toggler={this.reportHandler} horse={horse} />
        <DieReport isVisible={isDieBoxVisible} toggler={this.dieHandler} horse={horse} />
        <Col xs={12}>
          <Row>
            <Col xs={3} className="Sire">
              <Row>
                {horse.sire.key ? <Link to={`/horse/${horse.sire.key}`}><Image src={(horse.sire.avatar) ? horse.sire.avatar : horseAvatar} alt="" className="Avatar" /></Link> : <Image src={horseAvatar} alt="" className="Avatar" />}
                <h5 className="Name"><Link to={`/horse/${horse.sire.key}`}>{horse.sire.name}</Link></h5>
                <h6 className="Strain">{horse.sire.strain !== null ? horse.sire.strain : '(نامشخص)'}</h6>
              </Row>
            </Col>
            <Col xs={6} className="Horse">
              <Row>
                <Link to={`/horse/${horse.key}`}><Image src={(horse.avatar) ? horse.avatar : horseAvatar} alt="" className="Avatar" /></Link>
                <div className="IconsHolder">
                  <OverlayTrigger placement="top" overlay={<Tooltip id="horse-count-like">{horse.likes.count}</Tooltip>}>
                    <MdFavorite className={horse.likes.isLike ? 'Heart active' : 'Heart'} onClick={this.likeHandler} />
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip id="horse-report">گزارش اشکالات در اطلاعات</Tooltip>} >
                    <MdReport className="Report" onClick={() => this.reportHandler(true)} />
                  </OverlayTrigger>
                  <OverlayTrigger placement="top" overlay={<Tooltip id="horse-report">گزارش تاریخ مرگ</Tooltip>} >
                    <IoIosPulseStrong className="Dead" onClick={() => this.dieHandler(true)} />
                  </OverlayTrigger>
                </div>
                <h3 className="Name"><Link to={`/horse/${horse.key}`}>{horse.name}</Link></h3>
                <h4 className="Strain">{horse.strain !== null ? horse.strain : '(نامشخص)'}</h4>
              </Row>
            </Col>
            <Col xs={3} className="Dam">
              <Row>
                {horse.dam.key ? <Link to={`/horse/${horse.dam.key}`}><Image src={(horse.dam.avatar) ? horse.dam.avatar : horseAvatar} alt="" className="Avatar" /></Link> : <Image src={horseAvatar} alt="" className="Avatar" />}
                <h5 className="Name"><Link to={`/horse/${horse.dam.key}`}>{horse.dam.name}</Link></h5>
                <h6 className="Strain">{horse.dam.strain !== null ? horse.dam.strain : '(نامشخص)'}</h6>
              </Row>
            </Col>
          </Row>
          <Row className="Info TopBox">
            <Col xs={4}>
              <h7>تولد</h7>
              <p>{horse.born !== null ? horse.born : '(نامشخص)'}</p>
            </Col>
            <Col xs={4}>
              <h7>پروش‌دهنده</h7>
              <p>{horse.breeder.name !== null ? <Link to={`/breeder/${horse.breeder.key}`}>{horse.breeder.name}</Link> : '(نامشخص)'}</p>
            </Col>
            <Col xs={4}>
              <h7>جنسیت</h7>
              <p>{horse.gender !== null ? horse.gender : '(نامشخص)'}</p>
            </Col>
          </Row>
          <Row className="Info BottomBox">
            <Col xs={4}>
              <h7>رنگ</h7>
              <p>{horse.color !== null ? horse.color : '(نامشخص)'}</p>
            </Col>
            <Col xs={4}>
              <h7>شماره ثبت</h7>
              <p>{horse.regNo !== null ? horse.regNo : '(نامشخص)'}</p>
            </Col>
            <Col xs={4}>
              <h7>سریال</h7>
              <p>{horse.srNo !== null ? horse.srNo : '(نامشخص)'}</p>
            </Col>
          </Row>
          <Row className="Info BottomBox">
            <Col xs={4}>
              <h7>مکان</h7>
              <p>(نامشخص)</p>
            </Col>
            <Col xs={4} className="owner">
              <h7>مالک</h7>
              {horse.owners.length > 0
                ? <OverlayTrigger trigger="click" rootClose placement="top" overlay={ownerList}>
                  <p><OverlayTrigger placement="top" overlay={<Tooltip id="horse-report">تاریخچه‌ی مالکین</Tooltip>}><MdHistory /></OverlayTrigger>{horse.owners[0].name}</p>
                </OverlayTrigger>
                : <p>(نامشخص)</p>}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

HorseDetails.propTypes = {
  info: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    currentHorse: state.horse.currentHorse
  }
}

export default connect(mapStateToProps)(HorseDetails)



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseDetails.js